import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, Col, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, FormGroup } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { toastError, toastSuccess } from "../../helpers/msg_helper"
import "../Tenancy/tenancy.css"
import { getAttendanceCodes, saveAttendanceCode, deleteAttendanceCode } from "../../services/admin"

const empty = {
  code: "", label: "", category: "other", hours_substitute: "", present_flag: "", counts_as: "",
  is_paid: false, deduction_type: "none", deduction_threshold_days: "", status_effect: "none",
  color_hex: "", is_in_form_ui: true, is_active: true, paid_hours_confirmed: true,
}
const CATS = ["absent", "present", "transit", "holiday", "leave", "medical", "training", "other"]
const COUNTS = ["", "worked", "paid_leave", "unpaid_leave", "holiday", "absent", "disciplinary", "lifecycle"]
const PRESENT = ["", "present", "absent", "neutral"]
const DEDUCT = ["none", "absent_25", "no_salary", "penalty"]
const STATUS = ["none", "VACATION", "ABSCOND", "FINISH", "OUTSIDE", "ACTIVE_NOT_STARTED"]

const AttendanceCodes = ({ embedded }) => {
  document.title = "Attendance Codes | Everrise"
  const [rows, setRows] = useState([])
  const [reload, setReload] = useState(0)
  const [modal, setModal] = useState(false)
  const [form, setForm] = useState(empty)

  useEffect(() => {
    ;(async () => {
      try { const r = await getAttendanceCodes(); setRows(r?.data || []) } catch (e) { toastError(e?.message) }
    })()
  }, [reload])

  const open = item => { setForm(item ? { ...empty, ...item, hours_substitute: item.hours_substitute ?? "", deduction_threshold_days: item.deduction_threshold_days ?? "" } : empty); setModal(true) }
  const save = async () => {
    try {
      const payload = { ...form, hours_substitute: form.hours_substitute === "" ? null : form.hours_substitute, deduction_threshold_days: form.deduction_threshold_days === "" ? null : form.deduction_threshold_days, present_flag: form.present_flag || null, counts_as: form.counts_as || null }
      await saveAttendanceCode(form.id, payload)
      toastSuccess("Saved"); setModal(false); setReload(reload + 1)
    } catch (e) { toastError(e?.message || (e?.errors && Object.values(e.errors)[0][0]) || "Save failed") }
  }
  const remove = async id => { if (!window.confirm("Delete code?")) return; try { await deleteAttendanceCode(id); toastSuccess("Deleted"); setReload(reload + 1) } catch (e) { toastError(e?.message) } }
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  return (
    <div className={embedded ? "" : "page-content tnt-scope"}>
      <div className={embedded ? "" : "container-fluid"}>
        {embedded ? (
          <div className="d-flex justify-content-end mb-2 app-tab-add">
            <Button color="primary" size="sm" onClick={() => open(null)}>+ Code</Button>
          </div>
        ) : (
          <div className="d-flex justify-content-between align-items-center">
            <Breadcrumbs title="Administration" breadcrumbObject={[{ title: "Administration", link: "#" }, { title: "Attendance Codes", link: "#" }]} />
            <Button color="primary" size="sm" onClick={() => open(null)}>+ Code</Button>
          </div>
        )}
        <Card className="me-2 px-2 pb-2 main-dashboard-bg"><CardBody>
        <Table responsive borderless className="align-middle tnt-table">
          <thead><tr><th>Code</th><th>Label</th><th>Category</th><th>Counts as</th><th>Paid</th><th>Status effect</th><th>Active</th><th></th></tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td>{r.color_hex && <span style={{ display: "inline-block", width: 10, height: 10, background: r.color_hex, borderRadius: 2, marginRight: 6 }} />}{r.code}</td>
                <td>{r.label}</td><td>{r.category}</td><td>{r.counts_as || "—"}</td><td>{r.is_paid ? "Yes" : "No"}</td><td>{r.status_effect}</td>
                <td>{r.is_active ? <span className="badge bg-success">Active</span> : <span className="badge bg-secondary">Inactive</span>}</td>
                <td className="text-nowrap"><i className="uil-pen action-icon" role="button" title="Edit" onClick={() => open(r)} /><i className="uil-trash-alt action-icon danger" role="button" title="Delete" onClick={() => remove(r.id)} /></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan="8" className="text-center text-muted">No codes</td></tr>}
          </tbody>
        </Table>
      </CardBody></Card>
      </div>

      <Modal isOpen={modal} toggle={() => setModal(false)} size="lg">
        <ModalHeader toggle={() => setModal(false)}>{form.id ? "Edit" : "New"} Attendance Code</ModalHeader>
        <ModalBody><Row>
          <Col md={3}><FormGroup><Label>Code *</Label><Input value={form.code} onChange={e => set("code", e.target.value)} /></FormGroup></Col>
          <Col md={5}><FormGroup><Label>Label *</Label><Input value={form.label} onChange={e => set("label", e.target.value)} /></FormGroup></Col>
          <Col md={4}><FormGroup><Label>Category</Label><Input type="select" value={form.category} onChange={e => set("category", e.target.value)}>{CATS.map(c => <option key={c}>{c}</option>)}</Input></FormGroup></Col>
          <Col md={4}><FormGroup><Label>Counts as</Label><Input type="select" value={form.counts_as} onChange={e => set("counts_as", e.target.value)}>{COUNTS.map(c => <option key={c} value={c}>{c || "—"}</option>)}</Input></FormGroup></Col>
          <Col md={4}><FormGroup><Label>Present flag</Label><Input type="select" value={form.present_flag} onChange={e => set("present_flag", e.target.value)}>{PRESENT.map(c => <option key={c} value={c}>{c || "—"}</option>)}</Input></FormGroup></Col>
          <Col md={4}><FormGroup><Label>Hours substitute</Label><Input value={form.hours_substitute} onChange={e => set("hours_substitute", e.target.value)} /></FormGroup></Col>
          <Col md={4}><FormGroup><Label>Deduction type</Label><Input type="select" value={form.deduction_type} onChange={e => set("deduction_type", e.target.value)}>{DEDUCT.map(c => <option key={c}>{c}</option>)}</Input></FormGroup></Col>
          {form.deduction_type === "absent_25" && <Col md={4}><FormGroup><Label>Threshold days *</Label><Input value={form.deduction_threshold_days} onChange={e => set("deduction_threshold_days", e.target.value)} /></FormGroup></Col>}
          <Col md={4}><FormGroup><Label>Status effect</Label><Input type="select" value={form.status_effect} onChange={e => set("status_effect", e.target.value)}>{STATUS.map(c => <option key={c}>{c}</option>)}</Input></FormGroup></Col>
          <Col md={3}><FormGroup><Label>Colour (#hex)</Label><Input value={form.color_hex || ""} onChange={e => set("color_hex", e.target.value)} /></FormGroup></Col>
          <Col md={3}><FormGroup check className="mt-4"><Input type="checkbox" checked={form.is_paid} onChange={e => set("is_paid", e.target.checked)} /> <Label check>Paid</Label></FormGroup></Col>
          <Col md={3}><FormGroup check className="mt-4"><Input type="checkbox" checked={form.is_in_form_ui} onChange={e => set("is_in_form_ui", e.target.checked)} /> <Label check>In form</Label></FormGroup></Col>
          <Col md={3}><FormGroup check className="mt-4"><Input type="checkbox" checked={form.is_active} onChange={e => set("is_active", e.target.checked)} /> <Label check>Active</Label></FormGroup></Col>
        </Row></ModalBody>
        <ModalFooter><Button color="light" onClick={() => setModal(false)}>Cancel</Button><Button color="primary" onClick={save}>Save</Button></ModalFooter>
      </Modal>
    </div>
  )
}

export default AttendanceCodes
